// removed by extract-text-webpack-plugin
module.exports = {"Title":"_1WinAoZEgzY5dT3kSvN3DD","Row":"_1u1W3OkxKDd6wz4_usVJVj","Input":"_2HclbKWbCHR_6gWogC9Ycs"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryChangeName/styles.module.css
// module id = 570
// module chunks = 0